export var TaskSubtype;
(function (TaskSubtype) {
    TaskSubtype["CREATE"] = "CREATE";
    TaskSubtype["DELETE"] = "DELETE";
    TaskSubtype["UPDATE"] = "UPDATE";
    TaskSubtype["COPY"] = "COPY";
    TaskSubtype["CANCEL"] = "CANCEL";
})(TaskSubtype || (TaskSubtype = {}));
